import React from 'react';

export const GroupSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.725 21.5h1.923c1.885 0 3.352-1.575 3.352-3.44 0-.91-.288-1.944-1.116-2.654-1.042-.892-3.008-2.128-5.884-2.128-.46 0-.086-.057-.5 0 .983.513 1.8 1.341 2.5 2.222 1.508.285 1.963.894 2.583 1.425.247.212.417.6.417 1.136 0 .83-.64 1.439-1.352 1.439h-1.2a5.2 5.2 0 0 1-.723 2m-4.002-10.035c.662.41 1.44.646 2.277.646 2.48 0 4.429-2.074 4.429-4.555C20.429 5.074 18.479 3 16 3c-.582 0-1.135.114-1.64.321.377.55.673 1.16.868 1.812Q15.596 5.002 16 5c1.307 0 2.429 1.11 2.429 2.556S17.307 10.11 16 10.11c-.407 0-.796-.107-1.138-.299a6.5 6.5 0 0 1-1.139 1.653"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 7a5 5 0 1 1 10 0A5 5 0 0 1 4 7m5 8c-2.704 0-4.522 1.113-5.469 1.895-.33.273-.531.746-.531 1.36C3 19.22 3.781 20 4.744 20h8.512c.963 0 1.744-.781 1.744-1.744 0-.615-.2-1.088-.531-1.361C13.522 16.113 11.704 15 9 15m-6.742.353C3.455 14.364 5.708 13 9 13c3.293 0 5.545 1.364 6.742 2.353.924.763 1.258 1.89 1.258 2.903A3.745 3.745 0 0 1 13.255 22h-8.51A3.745 3.745 0 0 1 1 18.256c0-1.014.334-2.14 1.258-2.903"
            clipRule="evenodd"
        />
    </svg>
);
